module.exports = __webpack_public_path__ + "img/special_offer.f9e8edad.png";